import React, { useState } from "react";
import { Typography, CircularProgress, Backdrop } from "@mui/material";
import StyledTextField from "../../components/shared/StyledTextField";
import StyledButton from "../../components/shared/StyledButton";
import {
  MainContainer,
  LoginPanel,
  Content,
  HeroImage,
  FormContainer,
  Logo,
  Form,
  Footer,
  ForgotPasswordLink,
  ForgotPasswordText,
} from "./Login.styles";
import api from "../../api/config";
import { ForgotPasswordApi } from "../../api/Authentication";
import { ArrowBack } from "@mui/icons-material";
import Notification from "../../components/shared/Notification";

const ForgotPassword = ({ showNotification }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [isLinkSent, setIsLinkSent] = useState(false);
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await api.post(
        `${ForgotPasswordApi}?login_location=dashboard`,
        { email }
      );
      console.log("Reset password response:", response);

      const message = response.data.status || "Unexpected response";
      setNotification({
        open: true,
        message,
        severity: "success",
      });
      setIsLinkSent(true);
    } catch (error) {
      console.error("Reset password error:", error);
      const errorMessage =
        error.response?.data?.detail || "Failed to send reset link";
      setNotification({
        open: true,
        message: errorMessage,
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainContainer>
      <Notification
        open={notification.open}
        message={notification.message}
        severity={notification.severity}
        handleClose={() => setNotification({ ...notification, open: false })}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <LoginPanel>
        <Content>
          <HeroImage
            src={require("../../assets/images/mammo_login_image.png")}
            alt="Hero"
          />
          <FormContainer>
            <Logo
              src={require("../../assets/images/nexus_logo.png")}
              alt="Logo"
            />
            {!isLinkSent ? (
              <Form onSubmit={handleResetPassword}>
                <Typography variant="h6" style={{ marginBottom: "20px" }}>
                  Forgot Password
                </Typography>
                <Typography
                  variant="body2"
                  style={{ marginBottom: "20px", color: "#9DA2A7" }}
                >
                  Enter your email address, and we will send you a link to reset
                  your password.
                </Typography>
                <StyledTextField
                  label="Email"
                  variant="outlined"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  fullWidth
                  margin="normal"
                  InputLabelProps={{
                    shrink: Boolean(email) || undefined,
                  }}
                />
                <div style={{ marginTop: "50px" }}>
                  <StyledButton type="submit" variant="contained" fullWidth>
                    Send Reset Link
                  </StyledButton>
                </div>
                <ForgotPasswordText
                  variant="body2"
                  style={{ marginTop: "20px" }}
                >
                  <ForgotPasswordLink href="/login">
                    <div style={{ display: "flex", justifyContent: "right" }}>
                      <div style={{ marginTop: "auto", marginBottom: "auto" }}>
                        <ArrowBack></ArrowBack>
                      </div>
                      <div style={{ marginTop: "auto", marginBottom: "auto" }}>
                        Back to Login
                      </div>
                    </div>
                  </ForgotPasswordLink>
                </ForgotPasswordText>
              </Form>
            ) : (
              <div style={{ textAlign: "center" }}>
                <Typography
                  variant="h6"
                  style={{ marginBottom: "20px", color: "#A5E0FF" }}
                >
                  Password Reset Link Sent
                </Typography>
                <Typography
                  variant="body2"
                  style={{ marginBottom: "10px", color: "#9DA2A7" }}
                >
                  A password reset link has been sent to {email}. Please check
                  your email.
                </Typography>
                <Typography
                  variant="body2"
                  style={{ color: "#9DA2A7", marginBottom: "10px" }}
                >
                  Didn’t receive the email? Click here!{" "}
                  <ForgotPasswordLink href="#" onClick={handleResetPassword}>
                    Resend the link.
                  </ForgotPasswordLink>
                </Typography>
                <Typography
                  variant="body2"
                  style={{
                    color: "#9DA2A7",
                    marginTop: "20px",
                    marginBottom: "20px",
                  }}
                >
                  For further assistance, call us at <b>415-523-4442</b>.
                </Typography>
                <ForgotPasswordLink href="/login">
                  <div style={{ display: "flex", justifyContent: "right" }}>
                    <div style={{ marginTop: "auto", marginBottom: "auto" }}>
                      <ArrowBack></ArrowBack>
                    </div>
                    <div style={{ marginTop: "auto", marginBottom: "auto" }}>
                      Back to Login
                    </div>
                  </div>
                </ForgotPasswordLink>
              </div>
            )}
            <Footer>
              <Typography
                variant="body2"
                style={{ color: "#9DA2A7", marginTop: "30px" }}
              >
                Powered by Nexus-MD
              </Typography>
            </Footer>
          </FormContainer>
        </Content>
      </LoginPanel>
    </MainContainer>
  );
};

export default ForgotPassword;
